// libs
import React, { ReactElement, useMemo } from "react";

import { PaymentAlert } from "@payment-ui/components/payment-alert";
import { OrderInterruptionAction, NavigateAction, PaymentAlertProps } from "@swiggy-private/payment-types";

export interface PaymentMaxRetriesAlertProps extends PaymentAlertProps {
    actions: OrderInterruptionAction[];
}

function PaymentMaxRetriesAlert(props: PaymentMaxRetriesAlertProps): ReactElement {
    const primaryAction = useMemo(() => {
        const primaryActionData = (props.actions?.[0] as NavigateAction).actionData;

        let subText = "";

        if (primaryActionData?.orderAmount) {
            subText = `${primaryActionData?.orderAmount}`;
        }

        const itemsCount = Number(primaryActionData?.orderItemsCount);

        if (!isNaN(itemsCount)) {
            subText += " | " + (itemsCount === 1 ? "1 item" : ` ${itemsCount} Items`);
        }

        return {
            ...props.primaryAction,
            subText,
        };
    }, [props.actions, props.primaryAction]);

    return (
        <PaymentAlert
            {...props}
            primaryAction={primaryAction}
            hideCloseIcon={!props.secondaryAction}
            hideOnOverlayClick={false}
        />
    );
}

export default React.memo(PaymentMaxRetriesAlert);
